import { useTranslation } from "react-i18next";
import { faDownload } from "@fortawesome/pro-light-svg-icons";
import { VaporIcon } from "@vapor/react-icons";
import { Stack, Box, Typography, useTheme } from "@vapor/react-material";
import { useCallback } from "react";
import { useDownloadTaxSubmissionOriginalFile } from "../../../../../../core/api/use-download-tax-submission-original-file/useDownloadTaxSubmissionOriginalFile";
import { downloadFile } from "../../../../../../core/utils/downloadFile";

export const useGetCtaDownloadOriginalFile = (taxSubmissionId: string) => {
    const { t } = useTranslation();
    const theme = useTheme();

    const downloadOriginalMutation = useDownloadTaxSubmissionOriginalFile();

    const onClickDownloadOriginalFile = useCallback(async () => {
        try {
            const resourceData =
                await downloadOriginalMutation.mutateAsync(taxSubmissionId);

            const filename: string =
                t("views.home.components.filename.original_file") +
                " " +
                taxSubmissionId;

            await downloadFile(
                resourceData.content,
                filename,
                resourceData.type,
            );
        } catch {
            // error notification already shown by handleHttpError
        }
    }, [downloadOriginalMutation, taxSubmissionId, t]);

    return {
        element: (
            <Stack direction="row" onClick={onClickDownloadOriginalFile}>
                <VaporIcon icon={faDownload} color="interactive" />
                <Box sx={{ mr: 1 }} />
                <Typography color={theme.palette.primary.interactiveDefault}>
                    {t(
                        "views.home.components.tax_submission_detail_toolbar.other_actions.download_original_file",
                    )}
                </Typography>
            </Stack>
        ),
        loading: downloadOriginalMutation.isPending,
    };
};
